<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">

      <div class="form-col">
          <control type="hidden" v-model="violation.id" :hasError="!!errors.id" id="id"/>
      </div>

      <div class="form-col">
          <field :label="$t('violation.tr_date')" class="w-full mr-2 mb-2 md:mb-0">
              <control type="datetime-local" v-model="violation.tr_date"/>
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('punishment.violation')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="violationList" :placeholder="$t('punishment.placeholder.violation')" v-model="violation.violation_id" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('punishment.punishment')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="punishmentList" :placeholder="$t('punishment.placeholder.punishment')" v-model="violation.punishment_id" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.remarks')" class="w-full mr-2 mb-2 md:mb-0">
              <control type="textarea" :placeholder="$t('violation.placeholder.remarks')" v-model="violation.remarks"/>
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.proposed_by')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="employeeList" :placeholder="$t('violation.placeholder.proposed_by')" v-model="violation.proposed_by" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.hr_pic1')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="employeeList" :placeholder="$t('violation.placeholder.hr_pic1')" v-model="violation.hr_pic1" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.hr_pic2')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="employeeList" :placeholder="$t('violation.placeholder.hr_pic2')" v-model="violation.hr_pic2" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.witnees1')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="employeeList" :placeholder="$t('violation.placeholder.witnees1')" v-model="violation.witnees1" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.witnees2')" class="w-full mr-2 mb-2 md:mb-0">
              <control :options="employeeList" :placeholder="$t('violation.placeholder.witnees2')" v-model="violation.witnees2" />
          </field>
      </div>

      <div class="form-col">
          <field :label="$t('violation.expired_date')" class="w-full mr-2 mb-2 md:mb-0">
              <datepicker v-model="violation.expired_date" :enableTimePicker="false" name="expired_date" :auto-apply="true"></datepicker>
          </field>
      </div>

      <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
          <jb-buttons class="buttons-action-submit">
            <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
            <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
          </jb-buttons>
        </div>
      </div>
  </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import { getViolationData, getPunishmentData, getEmployeeData } from '@/composables/global'
import Loading from 'vue-loading-overlay'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
export default {
  name: 'ClassForm',
  components: {
      Field,
      Control,
      JbButton,
      JbButtons,
      Loading,
      Datepicker
  },
  props: {
      showEdit: { Boolean },
      propClass: {
          type: Object,
          default: () => ({ empty: true })
      },
      propObject: {
          type: Object,
          default: () => ({ empty: true })
      }
  },
  data: function () {
      return {
      }
  },
  emits: ['close-modal', 'submit', 'refresh-list'],
  setup (props, { emit }) {
      const titleStack = ref(['Admin', 'Forms'])
      const isLoading = ref(false)

      const toast = useToast()

      const router = useRouter()

      const errors = ref([])
      const preview = ref('')

      const str = useStore()
      const userlogin = localStorage.getItem('name')

      const { violationList } = getViolationData()
      const { punishmentList } = getPunishmentData()
        const userId = localStorage.getItem('user_id')
        const branchId = localStorage.getItem('branch_id')
        const { employeeList } = getEmployeeData({user_id:userId, branch_id:branchId})

      const violation = reactive({
          id: '',
          tr_date: '',
          expired_date: '',
          punishment_id: '',
          violation_id: '',
          remarks: '',
          proposed_by: '',
          hr_pic1: '',
          hr_pic2: '',
          witnees1: '',
          witnees2: '',
          created_by: '',
          updated_by: ''
      })

      const store = async () => {
        isLoading.value = true
          const url = props.showEdit ? 'employeviolation/' + violation.id : 'employeviolation';
          const method = props.showEdit ? "PUT" : "POST";

          violation.created_by = userlogin

          const jsonData = JSON.stringify(violation)

          const configHeaders = {
              "content-type": "application/json",
              "Accept": "application/json"
          };

          await axios({
                  method,
                  url,
                  data: jsonData,
                  headers: configHeaders
              })
              .then(response => {
                  if (response.data.success) {
                      emit('close-modal')
                      emit('refresh-list')
                      toast.success(response.data.message)
                  } else {
                      errors.value = response.data.messages
                      toast.error(response.data.messages)
                  }
                  isLoading.value = false
              })
              .catch(error => {
                  if (error.response) {
                      console.log(error)
                      toast.error(error.response.data.message)
                      console.log(JSON.stringify(error.request))
                  } else if (error.message) {
                      console.log(error.message)
                      toast.error(error.message)
                      console.log(JSON.stringify(error.message))
                  }
                  isLoading.value = false
              })
      }

      onBeforeMount(() => {
      })

      onMounted(() => {
          // violation.value =toRefs(props, 'propClass')
      })

      watchEffect(() => {
          const newobject = props.propObject;
          Object.assign(violation, newobject);

          if (!props.showEdit) {
              violation.id = null;
              violation.tr_date = null;
              violation.expired_date = null;
              violation.punishment_id = null;
              violation.violation_id = null;
              violation.remarks = null;
              violation.proposed_by = null;
              violation.hr_pic1 = null;
              violation.hr_pic2 = null;
              violation.witnees1 = null;
              violation.witnees2 = null;
          }

          const newposition = props.propClass
          violation.submenu = newposition.submenu
          violation.ein = newposition.ein
          violation.employee_id = newposition.employee_id
      })

      return {
          titleStack,
          mdiBallot,
          mdiCheckBold,
          router,
          violation,
          store,
          toast,
          userlogin,
          errors,
          violationList,
          punishmentList,
          employeeList,
          isLoading
      }
  },
  methods: {
      clearForm () {
          this.violation = reactive({
              id: '',
              tr_date: '',
              expired_date: '',
              punishment_id: '',
              violation_id: '',
              remarks: '',
              proposed_by: '',
              hr_pic1: '',
              hr_pic2: '',
              witnees1: '',
              witnees2: '',
              created_by: '',
              updated_by: ''
          })
      },
      onChange: function (department_id, event) {
          if (event.target.value) {
              department_id = event.target.value
          }
          this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
          this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
      }
  },
  created () {
      this.levelListFilter = this.levelList
      this.academicYearListFilter = this.academicYearList
  }
}
</script>